import { ReactComponent as Clock } from '../../assets/clock-ico.svg'
import { useTranslation } from 'react-i18next'
import style from './style.module.scss'
import clsx from 'clsx'

export const ReadingTime = ({ min, classNames }) => {
    const { t } = useTranslation()

    return (
        <div className={clsx(style.block, classNames)}>
            <span className={style.text}>{t('Temps de lecture')}</span>
            <Clock />
            <span className={style.min}>{min + ' min'}</span>
        </div>
    )
}
